import { MULTISIG_SIGNER_ROLE, MULTISIG_SIGNER_STATUS } from "@/constants/multisigEnrollment";

import type { ApiUser, MultisigActiveSigner } from "@/types";

export const toActiveSigners = (users: ApiUser[] | undefined | null): MultisigActiveSigner[] =>
  (users ?? [])
    .filter((user) => user.multisig_signer?.status === MULTISIG_SIGNER_STATUS.ACTIVE)
    .map((user) => ({
      user_id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      role: user.multisig_signer!.role,
      stellar_public_key: user.multisig_signer!.stellar_public_key ?? undefined,
    }));

/** Active signers holding the Owner signer role (weight 12 on-chain). */
export const activeOwnerSigners = (signers: MultisigActiveSigner[]): MultisigActiveSigner[] =>
  signers.filter((signer) => signer.role === MULTISIG_SIGNER_ROLE.OWNER);

export const findMySigner = (
  signers: MultisigActiveSigner[],
  userId: string | undefined | null,
): MultisigActiveSigner | null =>
  userId ? (signers.find((signer) => signer.user_id === userId) ?? null) : null;
